<template lang="pug">
    .interactive-place
        .interactive-place__font-size-scaling-bar
            input.scaling-bar.cr-slider(
                type='range',
                @change="resizeText($event)",
                step='1', min='18', :max='maxFontSize',
                :value='fontSize'
            )
            .scale-text-info {{ $i18n.t('trainer.trainer_game_shutter_scale', {element: scaleElement}) }}
</template>

<script>
    import textScrollMixin from '../../../../utils/trainer/textScroll';

    const LINE = 'Тестовая строка. ';
    const LINE_REPETITIONS_NUMBER = 20;

    export default {
        props: {
            elementName: String,
            isGameTuned: Boolean,
            isFromShutter: {
                type: Boolean,
                default: false,
            },
            invertedItem: {
                type: Boolean,
                default: false,
            },
            isItemColumnMode: {
                type: Boolean,
                default: false,
            },
            amountOfWords: {
                type: Number,
                default: 10,
            },
            rowsName: String,
            fontSize: [Number, String],
            scaleElement: {
                type: String,
                default() {
                    return this.$i18n.tc('trainer.trainer_gamePlayBox_words');
                },
            },
            isAnagrams: {
                type: Boolean,
                default: false,
            },
            isAnagramsWithTime: {
                type: Boolean,
                default: false,
            },
            isMobilePhone: {
                type: Boolean,
                default: false,
            },
        },
        mixins: [textScrollMixin],
        created() {
            document.addEventListener('keydown', this.doneOnEnter);
        },
        mounted() {
            this.gameBoxName = 'test-text-container';
        },
        methods: {
            resizeText(event) {
                let fontSize = event.target.value;
                if (!this.isAnagramsWithTime) {
                    this.element.style.fontSize = fontSize + 'px';
                } else {
                    if (this.isMobilePhone) {
                        this.element.style.fontSize = fontSize * 1.4 + 'px';
                    } else {
                        this.element.style.fontSize = fontSize * 4 + 'px';
                    }
                }
                this.$emit('setFontSize', fontSize);
                if (this.isFromShutter) {
                    let height, width;
                    [height, width] = !this.isGameTuned
                        ? [this.$refs.wordLine[0].clientHeight, this.$refs.wordLine[0].clientWidth]
                        : [0, 0];
                    this.$emit('setHeight', height, width);
                }
            },
            doneOnEnter(event) {
                if (event.keyCode === 13) {
                    document.removeEventListener('keydown', this.doneOnEnter);
                    this.$emit('doneWithPreparing');
                }
            },
        },
        computed: {
            element() {
                if (this.isGameTuned) {
                    return document.querySelector(`.${this.elementName}`);
                }
                return document.querySelector('.test-text-container');
            },
            displayedTestLines() {
                if (!this.isGameTuned) {
                    let line_number = this.isItemColumnMode ? this.amountOfWords : LINE_REPETITIONS_NUMBER;
                    let text = LINE.repeat(line_number);
                    let displayedLines = [];
                    if (this.isItemColumnMode) {
                        displayedLines = _.take(text.match(/[^.!?]+[.!?"'»]+/g), this.amountOfWords);
                    } else {
                        displayedLines = _.chunk(text.split(' '), this.amountOfWords);
                        displayedLines = _.map(displayedLines, arr => arr.join(' '));
                    }
                    return displayedLines;
                }
                return [];
            },
            maxFontSize() {
                const WindowWidth = document.documentElement.clientWidth;
                if (WindowWidth < 576) {
                    return 30;
                } else if (WindowWidth < 766) {
                    return 40;
                } else if (WindowWidth < 1200) {
                    return 60;
                } else if (WindowWidth < 1430) {
                    return 80;
                } else if (WindowWidth < 1920) {
                    return 100;
                }
                return 150;
            },
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.doneOnEnter);
        },
    };
</script>

<style lang="scss" scoped>
    .scale-text-info {
        font-size: 18px;
        line-height: 21px;
        white-space: normal;
        margin-top: 10px;
    }

    .scaling-bar {
        -webkit-appearance: none;
        width: 100%;
        background: transparent;
        &:focus {
            outline: none;
        }
        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            height: 16px;
            width: 16px;
            border-radius: $border-radius-circle;
            background: $hsl-color-green-58;
            margin-top: -6px;
            cursor: pointer;
        }
        &::-moz-range-thumb {
            -webkit-appearance: none;
            height: 16px;
            width: 16px;
            border-radius: $border-radius-circle;
            background: $hsl-color-green-58;
            cursor: pointer;
        }
        &::-ms-thumb {
            -webkit-appearance: none;
            height: 16px;
            width: 16px;
            border-radius: $border-radius-circle;
            background: $hsl-color-green-58;
            cursor: pointer;
        }
        &::-webkit-slider-runnable-track {
            width: 100%;
            height: 6px;
            cursor: pointer;
            background: $hsl-color-gray-92;
            border-radius: $border-radius-40;
        }
    }

    .interactive-place {
        width: 100%;
        display: flex;
        flex-direction: column;
        max-width: 260px;
        @include media($md) {
            max-width: 460px;
        }
    }

    .interactive-place__font-size-scaling-bar {
        text-align: center;
        margin-bottom: 30px;
    }

    .test-text-container {
        text-align: center;
        font-size: 18px;
        white-space: normal;
        overflow: auto;
        cursor: pointer;
        user-select: none;
        @include scrollbar;
    }

    .inverted-word {
        display: inline-block;
        transform: rotate(180deg);
    }
</style>
